// extracted by mini-css-extract-plugin
module.exports = {"collapsed":"ContentViewRouter_collapsed__Knxgg","expanded":"ContentViewRouter_expanded__FyBlM","login":"ContentViewRouter_login__23T8Z"};